import classNames from 'classnames'
import React from 'react'
import { confirmBase } from 'utils/ui'
import EventEditor from './components/EventEditor'
import styles from './style.module.scss'

export function modalEventEditor(
  startDate: Date,
  endDate: Date,
  title: string,
  required?: unknown[],
  optional?: unknown[],
) {
  const attendees = {
    required: (required || []) as any[],
    optional: (optional || []) as any[],
  }

  const modalObj = confirmBase({
    wrapClassName: classNames('eventEditorModal', styles.externalEventEditor),
    className: classNames('mobile-fullpage'),
    open: true,
    footer: null,
    width: 640,
    destroyOnHidden: true,
    closable: false,
    content: (
      <EventEditor
        instance={null}
        date={startDate}
        targetDates={{ start: startDate, end: endDate }}
        title={title}
        attendees={attendees}
        onClose={() => modalObj.destroy()}
      />
    ),
  })
  return modalObj
}
